import { useEffect } from "react";
import { useSignal } from "@preact/signals-react";
import { layout as layoutRequestService } from "./ModelRequestService";
import Board from "componentsv2/board/Board";

const ScreenRequestService = () => {
  const layout = useSignal(null);
  const currentView = useSignal("list");

  useEffect(() => {
    async function fetchLayout() {
      const res = await layoutRequestService();
      layout.value = res;
    }
    fetchLayout();
  }, []);

  if (!layout.value) return null;

  return <Board layout={layout.value} currentView={currentView} />;
};
export default ScreenRequestService;
